import { render, staticRenderFns } from "./DualButtonComponent.vue?vue&type=template&id=72eeb429"
import script from "./DualButtonComponent.vue?vue&type=script&lang=js"
export * from "./DualButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./DualButtonComponent.vue?vue&type=style&index=0&id=72eeb429&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports